import React, { Suspense } from 'react';
import HttpService from '../views/services/components/httpservices.js';
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import { CContainer, CFade } from '@coreui/react'

// routes config
import { routes, innerRoute } from '../routes';

import { TitleComponent } from './TitleComponent.js';
const header = {
  'Content-Type': 'application/json',
  'authorization': localStorage.getItem("token")
};
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)


class TheContent extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      isUserLoged: true,
      isAdmin: false
    }

  }

  isExistUser = async () => {
    if (localStorage.getItem("userId")) {
      var response = await HttpService.get("get_user/", header).catch((error) => {
        return error;
      });
      if (response && (response.status === 201 || response.status === 200)) {
        return true;
      } else if (response && (response.response && response.response.data)) {
        var role = localStorage.getItem("role");
        if (role === "admin") {
          this.setState({
            isUserLoged: false,
            isAdmin: true
          });
        } else {
          this.setState({
            isUserLoged: false
          });
        }
      } else {
        this.setState({
          isUserLoged: false
        });
      }
    } else {
      this.setState({
        isUserLoged: false
      });
    }
  }
  componentDidMount() {
    this.isExistUser();
  }
  render() {

    const { isUserLoged, isAdmin } = this.state;
    if (!isUserLoged) {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("role");
      if (isAdmin) {
        return (
          <Redirect to="/login/admin" />
        );
      } else {
        return (
          <Redirect to="/login/user" />
        );
      }
    } else {
      return (
        <main className="c-main">
          <CContainer fluid>
            <Suspense fallback={loading}>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component && (

                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <CFade>
                          <TitleComponent title={route.name} />

                          <route.component {...props} />
                        </CFade>
                      )} />
                  )
                })}
                {innerRoute.map((route, idx) => {
                  return route.component && (

                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <CFade>
                          <TitleComponent title={route.name} />
                          <route.component {...props} />
                        </CFade>
                      )} />
                  )
                })}
                <Redirect to="/dashboard" />
              </Switch>
            </Suspense>
          </CContainer>
        </main>
      )
    }
  }
}

export default React.memo(TheContent);
